const state = {
    connected_wallet: null,
    dkz_balance: 0
}

const mutations = {
    CONNECT_WALLET: (state, walletAddress) => {
        state.connected_wallet = walletAddress
    },
    DKZ_BALANCE: (state, dkzBalance) => {
        state.dkz_balance = dkzBalance
    }
}

const actions = {
    connectWallet({commit}, status) {
        commit('CONNECT_WALLET', status)
    },
    dkzBalance({commit}, status) {
        commit('DKZ_BALANCE', status)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
